export const CHECKOUT_URL =
  'https://radiology-visual-atlas.impultienda.ar/checkout'
export const PURCHASE_ANCHOR = '#offer'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/pUSkcyYqPnEN1VrNnT6DyC/Diseno_sin_titulo-7.webp'

export interface InsideImage {
  src: string
  alt: string
}

export const insideImages: InsideImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/huwkhkzAMUuaJL3aHEUV6E/Captura_de_pantalla_2026-09-21_a_la(s)_3.59.43_p._m..png',
    alt: 'Bone anatomy on X-ray annotated reference page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jqtofXann3Eykbk1t5F56o/Captura_de_pantalla_2026-09-21_a_la(s)_4.00.08_p._m..png',
    alt: 'Wrist and hand imaging atlas reference page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hft689eMbtbjoiNa9J37vr/Captura_de_pantalla_2026-09-21_a_la(s)_4.00.24_p._m..png',
    alt: 'Joint-space and degenerative patterns comparison page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6x3kv3VnXGae2tHsdwtdeh/Captura_de_pantalla_2026-09-21_a_la(s)_4.00.45_p._m..png',
    alt: 'Transition to neuroimaging: how to orient the brain reference page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pFjyjL4Vb18sRwGAsmZzUa/Captura_de_pantalla_2026-09-21_a_la(s)_4.01.13_p._m..png',
    alt: 'Musculoskeletal and neuro pattern recognition board page',
  },
]

export const systemBullets = [
  'X-ray anatomy & interpretation',
  'CT imaging & cross-sectional anatomy',
  'MRI sequences & anatomy',
  'Chest & abdominal imaging',
  'Musculoskeletal & neuro imaging',
  'Pattern recognition & guided cases',
]

export interface Module {
  number: number
  title: string
  body: string
  steps: string
}

export const modules: Module[] = [
  {
    number: 1,
    title: 'X-RAY FUNDAMENTALS & INTERPRETATION ATLAS',
    body: 'Build a clearer foundation for understanding and reading radiographic images. Learn densities, projections, orientation, image quality, normal anatomy and systematic X-ray review across chest, abdomen and musculoskeletal imaging.',
    steps: 'Orient. Inspect. Recognize.',
  },
  {
    number: 2,
    title: 'CT IMAGING VISUAL ATLAS',
    body: 'Understand CT images and navigate cross-sectional anatomy more systematically. Explore axial, coronal and sagittal planes, Hounsfield densities, CT windows, contrast phases and essential head, chest, abdominal and pelvic anatomy.',
    steps: 'Navigate. Compare. Identify.',
  },
  {
    number: 3,
    title: 'MRI SEQUENCES & ANATOMY VISUAL ATLAS',
    body: 'Stop confusing MRI sequences and learn the visual clues that separate them. Compare T1, T2, FLAIR, DWI, ADC and fat-suppressed imaging while exploring brain, spine and musculoskeletal anatomy across common MRI planes.',
    steps: 'Compare. Decode. Recognize.',
  },
  {
    number: 4,
    title: 'CHEST & ABDOMINAL IMAGING ATLAS',
    body: 'Study important thoracic and abdominal imaging patterns through organized visual comparisons. Explore chest X-rays, CT anatomy, lung patterns, pleural findings, bowel gas patterns, abdominal structures, calcifications and normal-versus-abnormal appearances.',
    steps: 'Locate. Compare. Understand.',
  },
  {
    number: 5,
    title: 'MUSCULOSKELETAL & NEURO IMAGING ATLAS',
    body: 'Develop a systematic approach to bone, joint, brain and spine imaging. Study fractures, alignment, joint spaces, CT and MRI correlations, brain anatomy, density and signal changes, hemorrhage patterns, ischemic patterns and mass effect.',
    steps: 'Inspect. Describe. Recognize.',
  },
  {
    number: 6,
    title: 'PATTERN RECOGNITION & CASE ATLAS',
    body: 'Bring modalities, anatomy and imaging patterns together through structured practice. Work through normal-versus-abnormal comparisons, X-ray, CT and MRI cases, pattern-recognition exercises, image-reading frameworks and guided visual challenges.',
    steps: 'Observe. Compare. Recognize.',
  },
]

export interface Bonus {
  number: number
  title: string
  subtitle: string
  body: string
  steps: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'RADIOLOGY ANATOMY QUICK REFERENCE™',
    subtitle: 'Essential Imaging Anatomy in One Organized Reference',
    body: 'Quickly review essential anatomical structures across X-ray, CT and MRI with organized body-region maps, annotated landmarks and cross-sectional imaging references.',
    steps: 'Locate. Identify. Review.',
  },
  {
    number: 2,
    title: 'NORMAL vs ABNORMAL IMAGING COMPARISON GUIDE™',
    subtitle: 'Learn to Recognize What Changes on the Image',
    body: 'Compare expected imaging appearances with carefully selected abnormal patterns across chest, abdomen, brain, spine, bones and joints.',
    steps: 'Compare. Detect. Describe.',
  },
  {
    number: 3,
    title: 'CT & MRI SEQUENCE DECODER™',
    subtitle: 'Understand Windows, Densities, Signals and Sequences',
    body: 'Use practical comparison references for CT densities, windows and contrast phases plus T1, T2, FLAIR, DWI, ADC and fat-suppressed MRI sequences.',
    steps: 'Decode. Compare. Recognize.',
  },
  {
    number: 4,
    title: 'RADIOLOGY READING CHECKLISTS™',
    subtitle: 'Structured Review Frameworks for Common Imaging Studies',
    body: 'Use practical checklists for chest and abdominal X-rays, bone and joint imaging, head CT, chest and abdominal CT, brain MRI, spine MRI and MSK MRI.',
    steps: 'Check. Review. Organize.',
  },
  {
    number: 5,
    title: 'RADIOLOGY PATTERN PRACTICE WORKBOOK™',
    subtitle: 'Guided Exercises for Building Image Recognition Skills',
    body: 'Practice orientation, anatomy identification, normal-versus-abnormal comparison and pattern description through carefully selected guided imaging exercises.',
    steps: 'Observe. Practice. Reinforce.',
  },
]

export interface Differentiator {
  icon: string
  title: string
  body: string
}

export const differentiators: Differentiator[] = [
  {
    icon: '🩻',
    title: 'Practical visual references',
    body: 'Find the anatomy, modality or imaging concept you need when studying.',
  },
  {
    icon: '🔍',
    title: 'Structured learning system',
    body: 'Move from orientation and anatomy to comparison and pattern recognition.',
  },
  {
    icon: '⚡',
    title: '6 radiology study areas',
    body: 'X-ray, CT, MRI, chest and abdomen, MSK and neuro, plus integrated cases.',
  },
  {
    icon: '🔄',
    title: 'Ready to use again and again',
    body: 'Return to the atlas whenever you need to review an imaging concept.',
  },
]

export const offerBullets = [
  '6 comprehensive modules',
  '5 strategic bonuses',
  'X-ray anatomy & interpretation',
  'CT imaging & anatomy',
  'MRI sequences & references',
  'Chest, abdomen, MSK & neuro imaging',
  'Pattern recognition & guided practice',
]

export interface Testimonial {
  name: string
  role: string
  location: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Chloe Ashworth, 22',
    role: 'Radiography student, 2nd year',
    location: 'Leeds, United Kingdom',
    quote:
      'Before this I had lecture slides on one screen, three different textbooks open and a folder of random images with no order. The X-ray module fixed that in a week. I now orient the image, check densities and run the review sequence the same way every time — and my placement supervisor noticed the difference in how I describe what I see.',
  },
  {
    name: 'Daniel Okafor, 25',
    role: 'Medical student, clinical rotations',
    location: 'Toronto, Canada',
    quote:
      'MRI sequences were the part I quietly avoided. The T1 / T2 / FLAIR / DWI comparison pages finally made the differences visual instead of a list I had memorized and forgotten. Going into neuro rotation I could actually say which sequence I was looking at and why the signal mattered.',
  },
  {
    name: 'Megan Tyler, 24',
    role: 'Diagnostic imaging student',
    location: 'Melbourne, Australia',
    quote:
      'The normal-versus-abnormal comparisons are what make it worth it. Seeing the expected appearance right beside the changed one trains your eye far faster than reading a paragraph describing it. I use the chest and abdominal atlas before every imaging tutorial now.',
  },
  {
    name: 'Ryan Delaney, 27',
    role: 'Radiologic technologist student',
    location: 'Chicago, United States',
    quote:
      'I study after shifts, so I needed something I could open and use in twenty minutes without hunting for resources. I pick the modality, open the region, follow the references. The reading checklists alone saved me from missing obvious review steps under pressure.',
  },
  {
    name: 'Priya Raman, 23',
    role: 'Radiology student, final year',
    location: 'Manchester, United Kingdom',
    quote:
      'The CT module made cross-sectional anatomy click. Windows, Hounsfield densities and contrast phases were three separate confusing topics for me and now they read as one system. The pattern practice workbook is the closest thing to guided image-reading practice I have found for students.',
  },
]

export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'Who is this system for?',
    a: 'Radiology students, radiography students, medical students and healthcare learners studying diagnostic imaging.',
  },
  {
    q: 'Is this a physical product?',
    a: 'No. RADIOLOGY VISUAL ATLAS™ is a 100% digital resource.',
  },
  {
    q: 'Is this a training course or certification?',
    a: 'No. It is an educational visual study and reference system.',
  },
  {
    q: 'Is it another theory-heavy ebook?',
    a: 'No. It focuses on annotated imaging references, modality comparisons, anatomy, pattern recognition and structured study tools.',
  },
  {
    q: 'What areas are included?',
    a: 'X-ray, CT, MRI, chest and abdominal imaging, musculoskeletal and neuro imaging, and pattern-recognition practice.',
  },
  {
    q: 'Does this replace formal radiology training?',
    a: 'No. It is an educational study resource and does not replace formal training, clinical supervision or professional medical judgment.',
  },
  {
    q: 'How will I receive it?',
    a: "You'll receive immediate digital access after purchase.",
  },
  {
    q: 'What devices can I use it on?',
    a: 'Any device that opens PDF files — laptop, tablet, phone or desktop. You can also print the reference pages you use most.',
  },
  {
    q: 'Do I need previous imaging experience?',
    a: 'No. The system starts with orientation, densities and normal anatomy, then moves into comparisons and pattern recognition, so early students and more advanced learners can both use it.',
  },
  {
    q: 'How long do I keep access, and what if it is not for me?',
    a: 'Access is yours to keep and review whenever you need it. If it is not right for you, contact us within 7 days for a full refund according to the refund terms.',
  },
]

export interface PopupSale {
  name: string
  city: string
  country: string
}

export const popupSales: PopupSale[] = [
  { name: 'Emily W.', city: 'Manchester', country: 'United Kingdom' },
  { name: 'James C.', city: 'Toronto', country: 'Canada' },
  { name: 'Sophia M.', city: 'Austin', country: 'United States' },
  { name: 'Oliver B.', city: 'Melbourne', country: 'Australia' },
  { name: 'Grace T.', city: 'Leeds', country: 'United Kingdom' },
  { name: 'Ethan B.', city: 'Vancouver', country: 'Canada' },
  { name: 'Ava S.', city: 'Chicago', country: 'United States' },
  { name: 'Liam H.', city: 'Brisbane', country: 'Australia' },
  { name: 'Charlotte D.', city: 'Bristol', country: 'United Kingdom' },
  { name: 'Noah P.', city: 'Calgary', country: 'Canada' },
  { name: 'Isabella R.', city: 'Denver', country: 'United States' },
  { name: 'Jack M.', city: 'Perth', country: 'Australia' },
]
